import React, { PropTypes } from 'react';
import { Navbar } from 'react-bootstrap';
import { Link } from 'react-router';

class TrialBalance extends React.Component {
   render() {
      return (
         <div className="TrialBalance" >
            <Navbar>
               <Navbar.Header>
                  <Navbar.Brand>
                     <Link to="/trialBalance/" activeStyle={{ color: 'red' }} >TrialBalance</Link>
                  </Navbar.Brand>
               </Navbar.Header>
            </Navbar>
            {this.props.children}
         </div>
      );
   }
}

TrialBalance.propTypes = {
   children: PropTypes.object
};

export default TrialBalance;



/** WEBPACK FOOTER **
 ** ./src/components/AccountingManagement/TrialBalance/TrialBalance.js
 **/